<div class="dialog-simple" cdkTrapFocus>
  <div class="close-button">
    <app-dialog-close-button (buttonClick)="close.emit()"></app-dialog-close-button>
  </div>

  <div class="dialog-simple-content">
    <img *ngIf="icon" src="{{ icon | cheminAbsoluStatique }}" class="icon" alt="" width="48" height="48" />

    <h1
      cdkFocusInitial
      appFocusOnInit
      tabindex="-1"
      class="title"
      *ngIf="textContent.title"
      [id]="textContent.titleId ? textContent.titleId : 'titre-modale'"
    >
      {{ textContent.title | translate }}
    </h1>

    <p
      class="paragraph"
      *ngIf="textContent.paragraph"
      [innerHtml]="textContent.paragraph | translate"
      [id]="textContent.paragraphId ? textContent.paragraphId : 'texte-modale'"
    ></p>

    <ng-content select="div.dialog-simple-multiple-content" *ngIf="!textContent.paragraph"></ng-content>

    <div class="buttons">
      <button
        *ngIf="textContent.cancelButton"
        mat-button
        [id]="textContent.cancelButtonId ? textContent.cancelButtonId : 'btn-annuler'"
        (click)="close.emit()"
        class="white full-width-xs"
      >
        {{ textContent.cancelButton | translate }}
      </button>

      <button
        mat-button
        [id]="textContent.confirmButtonId ? textContent.confirmButtonId : 'btn-confirmer'"
        (click)="confirm.emit()"
        class="green full-width-xs"
        #confirmButton
      >
        {{ textContent.confirmButton | translate }}
      </button>
    </div>
  </div>
</div>
